module.exports = __webpack_public_path__ + "img/f.a2aca2e1.jpg";